import { sharedCatalog } from "@shared/locales/en/US/sharedCatalog";

export const catalog = {
  ...sharedCatalog,
  ViewSimilarProducts: "View similar products",
  QuickView: "Quick view",
  LoginToViewPrice: "Sign in to view price",
} as const;
